module.exports = __webpack_public_path__ + "static/media/background.9ec3b401.jpg";